import { Component, OnInit } from '@angular/core';
import { AttendanceService } from 'src/app/services/attendance/attendance.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import * as moment from 'moment'

@Component({
  selector: 'app-monthly-student-attendance',
  templateUrl: './monthly-student-attendance.component.html',
  styleUrls: ['./monthly-student-attendance.component.css']
})
export class MonthlyStudentAttendanceComponent implements OnInit {


  constructor(private attendanceservice: AttendanceService, private lookupservice: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }

  ClassList: any;
  SectionList: any;
  YearList:any;
  StudentMonthlyAttendanceList: any;
  StudentMonthlyDayList:any;
  CurrentStatusHeader:any;
  Submitted: boolean = false;


  StudentMonthlyAttendanceModel = {
    StudentAttendanceID: 0,
    ClassID: 0,
    SectionID: 0,
    AtMonth:0,
    AtYear:0,
    ClassSectionID:'',
  }

  Clear() {
    this.StudentMonthlyAttendanceModel.ClassID = 0;
    this.StudentMonthlyAttendanceModel.SectionID = 0;
    this.StudentMonthlyAttendanceModel.AtMonth = 0;
    this.StudentMonthlyAttendanceModel.AtYear = 0;
    this.Submitted = false;
    this.StudentMonthlyAttendanceList=[];
  }
  SearchValidation() {
    return this.StudentMonthlyAttendanceModel.ClassID == 0 || this.StudentMonthlyAttendanceModel.SectionID == 0;
  }
  GetMonthlyStudentAttendance() {
    this.Submitted = true;
    this.StudentMonthlyAttendanceList=[];
    if (!this.SearchValidation()) {

      this.spinnerService.show();
      this.attendanceservice.GetMonthlyStudentAttendance(JSON.stringify(this.StudentMonthlyAttendanceModel)).subscribe((data: any) => {
        this.StudentMonthlyAttendanceList = data.StudentMonthlyAttendanceList;
        this.StudentMonthlyDayList=this.StudentMonthlyAttendanceList[0].DayList;
        this.CurrentStatusHeader=data.CurrentStatusHeader;
        this.Submitted = false;
        this.spinnerService.hide();
        this.globalHelper.CheckActionStatus(data);
      });
    }


  };


  SaveMonthlyStudentAttendance() {
    this.spinnerService.show();
    this.attendanceservice.SaveMonthlyStudentAttendance(JSON.stringify(this.StudentMonthlyAttendanceList), JSON.stringify(this.StudentMonthlyAttendanceModel)).subscribe((data: any) => {
      this.spinnerService.hide();
      this.GetMonthlyStudentAttendance();
      this.globalHelper.CheckActionStatus(data);

    });
  };

  ngOnInit() {
    
    var dtCurrent = new Date();
            var year = dtCurrent.getFullYear();
    this.YearList = [];
    var item = {
        ItemId: 0,
        ItemName: '---Select---'
    }
    this.YearList.push(item);
    for (var i = year; i >= year - 2; i--) {
        item = {
            ItemId: i,
            ItemName: i.toString()
        }
        this.YearList.push(item);
    }
    this.GetClassSection();
   
  }

  ClassSectionList: any;
  GetClassSection() {
    this.lookupservice.GetLookupsList('CTClassSection', '').subscribe((data) => {
      this.ClassSectionList = data.LookupItems;

    });

  };

  SetID() {

    this.StudentMonthlyAttendanceModel.ClassID = 0;
    this.StudentMonthlyAttendanceModel.SectionID = 0;
    if (this.StudentMonthlyAttendanceModel.ClassSectionID != "") {
      var strClassSectionID = this.StudentMonthlyAttendanceModel.ClassSectionID.split('-');
      this.StudentMonthlyAttendanceModel.ClassID = parseInt(strClassSectionID[0]);
      this.StudentMonthlyAttendanceModel.SectionID = parseInt(strClassSectionID[1]);

    }



  }

}


